import {useEventDelete} from '@hconnect/common/hooks/useEventDelete'
import {StoppageEvent} from '@hconnect/common/stoppages/types/stoppage.types'
import {spawnSuccessToast} from '@hm/fundamental'
import React, {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {ErrorDialog, ConfirmationDialog} from '../../components'
import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

type StoppageDeleteProps = {
  showDialog: boolean
  plantId: string
  stoppage: StoppageEvent
  setDialogOpen: (state: boolean) => void
  onSuccess: () => void
  onlyDeleteSeries?: boolean
}

export const StoppageDelete: React.FC<StoppageDeleteProps> = ({
  stoppage,
  onSuccess,
  showDialog,
  setDialogOpen,
  plantId
}) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)
  const handleDeleteSuccess = useCallback(() => {
    spawnSuccessToast(t('stoppage.deleteMessage.success'))
    onSuccess()
  }, [t, onSuccess])

  const eventDeleteAction = useEventDelete(plantId, {
    onSuccess: handleDeleteSuccess
  })

  return (
    <>
      {eventDeleteAction.error ? (
        <ErrorDialog
          httpCode={eventDeleteAction.error.code}
          onClose={() => {
            setDialogOpen(false)
            eventDeleteAction.reset()
          }}
          errorText={eventDeleteAction.error.message}
        />
      ) : (
        showDialog && (
          <ConfirmationDialog
            onDeleteSingle={() => {
              eventDeleteAction.mutate(stoppage.id)
            }}
            onClose={() => setDialogOpen(false)}
            isSingleLoading={eventDeleteAction.isPending}
            title={stoppage.title ?? ''}
            isSeriesItem={false}
          />
        )
      )}
    </>
  )
}
